"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Modal = exports.RawModal = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _redux = require("redux");

var _actionCreators = require("./actionCreators");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var initialState = {
  display: false,
  translate: true
};

var RawModal = /*#__PURE__*/function (_Component) {
  _inherits(RawModal, _Component);

  var _super = _createSuper(RawModal);

  function RawModal() {
    var _this;

    _classCallCheck(this, RawModal);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "handleActiveChange", function () {
      var prevProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$props = _this.props,
          isActive = _this$props.isActive,
          transitionDuration = _this$props.transitionDuration;

      if (isActive && !prevProps.isActive) {
        // Opening
        _this.setState({
          display: true
        });

        _this.openTimeout = setTimeout(function () {
          _this.setState({
            translate: false
          });
        }, transitionDuration);
        document.addEventListener('backbutton', _this.onCloseClick);
      } else if (!isActive && prevProps.isActive) {
        // Closing
        _this.setState({
          translate: true
        });

        _this.closeTimeout = setTimeout(function () {
          _this.setState({
            display: false
          });
        }, transitionDuration);
        document.removeEventListener('backbutton', _this.onCloseClick);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onCloseClick", function (event) {
      var _this$props2 = _this.props,
          dispatch = _this$props2.dispatch,
          name = _this$props2.name,
          isActive = _this$props2.isActive,
          isUnclosable = _this$props2.isUnclosable,
          onCloseClick = _this$props2.onCloseClick;
      if (isUnclosable || !isActive) return true;

      if (onCloseClick) {
        onCloseClick();
      }

      dispatch((0, _actionCreators.closeModal)(name));
      event.preventDefault();
      return event;
    });

    _defineProperty(_assertThisInitialized(_this), "stopPropagation", function (event) {
      event.nativeEvent.stopImmediatePropagation(); // Prevent click bubbling and closing modal

      event.stopPropagation();
      return event;
    });

    _this.state = initialState;
    return _this;
  }

  _createClass(RawModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleActiveChange();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          dispatch = _this$props3.dispatch,
          isClosingOnLocationChange = _this$props3.isClosingOnLocationChange,
          name = _this$props3.name,
          pathname = _this$props3.location.pathname;

      if (isClosingOnLocationChange && pathname !== prevProps.location.pathname) {
        dispatch((0, _actionCreators.closeModal)(name));
      }

      this.handleActiveChange(prevProps);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.openTimeout) {
        clearTimeout(this.openTimeout);
      }

      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout);
      }
    }
  }, {
    key: "transform",
    value: function transform() {
      var fromDirection = this.props.fromDirection;
      var translate = this.state.translate;
      if (!translate) return '';

      switch (fromDirection) {
        case 'top':
          return 'translate(0, -100vh)';

        case 'bottom':
          return 'translate(0, 100vh)';

        case 'left':
          return 'translate(-100vw, 0)';

        case 'right':
          return 'translate(100vw, 0)';

        default:
          return {};
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          closeImgPath = _this$props4.closeImgPath,
          extraClassName = _this$props4.extraClassName,
          fullscreen = _this$props4.fullscreen,
          hasCloseButton = _this$props4.hasCloseButton,
          isUnclosable = _this$props4.isUnclosable,
          maskColor = _this$props4.maskColor,
          contentElement = _this$props4.contentElement,
          transitionDuration = _this$props4.transitionDuration;
      var display = this.state.display;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('modal', extraClassName, {
          active: display
        }),
        role: "button",
        style: {
          backgroundColor: maskColor
        },
        onClick: this.onCloseClick,
        onKeyPress: this.onCloseClick,
        tabIndex: 0
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "container"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])('modal-dialog', {
          fullscreen: fullscreen
        }),
        onClick: function onClick(e) {
          return _this2.stopPropagation(e);
        },
        onKeyPress: function onKeyPress(e) {
          return _this2.stopPropagation(e);
        },
        role: "button",
        style: {
          transform: this.transform(),
          transitionDuration: "".concat(transitionDuration, "ms")
        },
        tabIndex: 0
      }, !isUnclosable && hasCloseButton && closeImgPath && /*#__PURE__*/_react["default"].createElement("button", {
        className: "close",
        onClick: this.onCloseClick,
        type: "button"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        alt: "modal close",
        src: closeImgPath
      })), contentElement && contentElement.type && /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-content"
      }, contentElement))));
    }
  }]);

  return RawModal;
}(_react.Component);

exports.RawModal = RawModal;
RawModal.defaultProps = {
  closeImgPath: null,
  contentElement: null,
  extraClassName: null,
  fromDirection: 'bottom',
  fullscreen: false,
  hasCloseButton: true,
  isActive: false,
  isClosingOnLocationChange: null,
  isUnclosable: false,
  maskColor: 'rgba(0, 0, 0, 0.8)',
  onCloseClick: null,
  transitionDuration: 250
};
RawModal.propTypes = {
  closeImgPath: _propTypes["default"].string,
  contentElement: _propTypes["default"].node,
  dispatch: _propTypes["default"].func.isRequired,
  extraClassName: _propTypes["default"].string,
  fromDirection: _propTypes["default"].string,
  fullscreen: _propTypes["default"].bool,
  hasCloseButton: _propTypes["default"].bool,
  isActive: _propTypes["default"].bool,
  isClosingOnLocationChange: _propTypes["default"].func,
  isUnclosable: _propTypes["default"].bool,
  location: _propTypes["default"].object.isRequired,
  maskColor: _propTypes["default"].string,
  name: _propTypes["default"].string.isRequired,
  onCloseClick: _propTypes["default"].func,
  transitionDuration: _propTypes["default"].number
};

function mapStateTopProps(state, ownProps) {
  var name = ownProps.name;
  var modals = state.modals;

  var _ref = modals[name] || {},
      config = _ref.config,
      contentElement = _ref.contentElement,
      isActive = _ref.isActive;

  return Object.assign({
    contentElement: contentElement,
    isActive: isActive
  }, config);
}

var Modal = (0, _redux.compose)(_reactRouterDom.withRouter, (0, _reactRedux.connect)(mapStateTopProps))(RawModal);
exports.Modal = Modal;
var _default = Modal;
exports["default"] = _default;